/* ============================================================================
 * PROJECT FILTER EVENT HANDLERS
 * Event handler functions for the ProjectFilterDropdown component
 * ============================================================================ */

/**
 * Toggle section expansion
 */
export const toggleSection = (
  section: string,
  expandedSections: Set<string>,
  setExpandedSections: (sections: Set<string>) => void
) => {
  const newExpanded = new Set(expandedSections);
  if (newExpanded.has(section)) {
    newExpanded.delete(section);
  } else {
    newExpanded.add(section);
  }
  setExpandedSections(newExpanded);
};
